import { LOGOUT } from "@/components/access/ducks/Actions"
import {
  CANCEL_SUBSCRIPTION,
  FETCH_DONATION_HISTORY,
  PROCESS_DONATION,
  PROCESS_DONATION_SESSION,
  RECEIVE_DONATION_HISTORY,
  RECEIVE_DONATION_SESSION_ID,
  UPDATE_DONATE_ON_HISTORY_OPEN,
  UPDATE_DONATION_AMOUNT,
  UPDATE_DONATION_AMOUNT_ERROR,
  UPDATE_DONATION_FREQUENCY,
  UPDATE_DONATION_GIVING_REASON_DETAIL,
  UPDATE_DONATION_GIVING_REASON_TYPE,
  UPDATE_DONATION_GIVING_REASON_VALUE,
  UPDATE_DONATION_ORGANIZATION,
  UPDATE_DONATION_ORGANIZATION_ERROR,
} from "@/components/donations/ducks/Actions"

const defaultDonation = {
  frequency: 0,
  amount: 0,
  organization: null,
  givingReasonType: "in_memory_of",
  givingReasonValue: "",
  givingReasonDetail: "",
  amountError: "",
  organziationError: "",
}

const defaultState = {
  ...defaultDonation,
  loadingDonations: false,
  cacheDonations: false,
  donateOnHistoryOpen: false,
  donations: [],
  donationsFetched: false,
}

const userDonationReducer = (oldState = defaultState, action) => {
  Object.freeze(oldState)
  switch (action.type) {
    case LOGOUT:
      return defaultState

    case RECEIVE_DONATION_HISTORY:
      return {
        ...oldState,
        donations: action.donations?.donations,
        loadingDonations: false,
        cacheDonations: true,
        donationsFetched: true,
      }

    case UPDATE_DONATE_ON_HISTORY_OPEN:
      return {
        ...oldState,
        donateOnHistoryOpen: action.open,
      }

    case FETCH_DONATION_HISTORY:
      if (oldState.cacheDonations) {
        return oldState
      }
      return {
        ...oldState,
        loadingDonations: true,
        donations: [],
      }

    case PROCESS_DONATION:
      return {
        ...oldState,
        ...defaultDonation,
        cacheDonations: false,
      }

    case PROCESS_DONATION_SESSION:
      return {
        ...oldState,
        ...defaultDonation,
        cacheDonations: false,
      }

    case RECEIVE_DONATION_SESSION_ID:
      return {
        ...oldState,
        cacheDonations: false,
        sessionId: action.sessionId,
      }

    case UPDATE_DONATION_FREQUENCY:
      return {
        ...oldState,
        frequency: action.interval,
      }

    case UPDATE_DONATION_AMOUNT:
      return {
        ...oldState,
        amount: action.amount,
        amountError: "",
      }

    case UPDATE_DONATION_AMOUNT_ERROR:
      return {
        ...oldState,
        amountError: action.amountError,
      }

    case UPDATE_DONATION_ORGANIZATION_ERROR:
      return {
        ...oldState,
        organizationError: action.organizationError,
      }

    case UPDATE_DONATION_ORGANIZATION:
      return {
        ...oldState,
        organization: action.organization,
        organizationError: "",
      }

    case UPDATE_DONATION_GIVING_REASON_TYPE:
      return {
        ...oldState,
        givingReasonType: action.givingReasonType,
      }

    case UPDATE_DONATION_GIVING_REASON_VALUE:
      return {
        ...oldState,
        givingReasonValue: action.givingReasonValue,
      }

    case CANCEL_SUBSCRIPTION:
      return {
        ...oldState,
      }

    case UPDATE_DONATION_GIVING_REASON_DETAIL:
      return {
        ...oldState,
        givingReasonDetail: action.givingReasonDetail,
      }
    default:
      return oldState
  }
}

export default userDonationReducer
